export interface IAppReportNewAppReportTemplateChange {
    appReportTemplateUnitIds: string[];
}

export class AppReportNewAppReportTemplateChange implements IAppReportNewAppReportTemplateChange {
    appReportTemplateUnitIds: string[];

    constructor();
    constructor(obj: IAppReportNewAppReportTemplateChange);
    constructor(obj?: any) {
        this.appReportTemplateUnitIds = obj?.appReportTemplateUnitIds ?? [];
    }
}